/**
 * Joins a bunch of optional class names together into a single string,
 * rejecting any values that equate to false (undefined, null, "")
 *
 * @param classes {Array<string>} array of classes
 * @returns {string} combined string
 */
export const joinClasses = (classes: Array<string | null | undefined>) =>
  classes.filter(Boolean).join(" ");
